import axios from 'axios'

export interface IBookListQueryParams {
  search?: string
}

export async function loadBookList({ search = '' }: IBookListQueryParams = {}) {
  const params = new URLSearchParams()

  if (search) {
    params.set('search', search)
  }

  return (await axios.get(`/api/books/?${params.toString()}`)).data
}

export async function loadBook(bookId: string) {
  return (await axios.get(`/api/books/${bookId}/`)).data
}